const BASE_URL = "https://docs.sanity.io/help/";
function generateHelpUrl(slug) {
  return BASE_URL + slug;
}
export { generateHelpUrl };
//# sourceMappingURL=generate-help-url.esm.js.map
